const hamburgerBtn = document.querySelector('#hamburger');
// const hamburgerBtnClose = document.querySelector('#hamburger-close');
const mainNav = document.querySelector('.mobile-navigation');
const page = document.querySelector("body");
const shutter = document.querySelector('.shutter');
const body = document.querySelector('body');

function header() {
  function handleMenuHamburger() {
    hamburgerBtn.addEventListener('click', () => {
      mainNav.classList.toggle('active');
      hamburgerBtn.classList.toggle('is-active');
      // hamburgerBtnClose.classList.add('is-active');
      page.classList.toggle('am-mobile-scroll');
      body.setAttribute('data-mobile-menu-active', '1');
    });
  }

  function closeMenu() {
    mainNav.classList.remove('active');
    hamburgerBtn.classList.remove('is-active');
    // hamburgerBtnClose.classList.remove('is-active');
    page.classList.remove('am-mobile-scroll');
    body.removeAttribute('data-mobile-menu-active');
  }

  // function handleMenuHamburgerMobileClose() {
  //   hamburgerBtnClose.addEventListener('click', () => {
  //     closeMenu();
  //   });
  // }

  function hideMobileMenuOnClickLink() {
    document.querySelector('.menu-item:not(.menu-item-has-children) > .menu-link')
        .addEventListener('click', () => {
          closeMenu();
        });
  }

  function hideMobileMenuOnClickOutside() {
    shutter.addEventListener('click', () => {
      closeMenu();
    });
  }




  handleMenuHamburger();
  // handleMenuHamburgerMobileClose();
  hideMobileMenuOnClickLink();
  hideMobileMenuOnClickOutside();
}

export default header;
